module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    ref: "contextmenu",
    staticClass: "contextMenu",
    class: {
      hide: !_vm.open
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      on: {
        "mousedown": function($event) {
          return _vm.onClick(item, $event)
        }
      }
    }, [(item.icon) ? _c('i', {
      staticClass: "fa",
      class: "fa-" + item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddfbe3fe","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ContextMenu.vue
// module id = 1287
// module chunks = 1